import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0b8cb326"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-tel"
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["telcenter", {
      fixed: $props.content.fixed
    }]),
    style: _normalizeStyle({
      'margin-top': $props.content.topMargin + 'px',
      'padding-left': $props.content.leftMargin + 'px',
      'padding-right': $props.content.rightMargin + 'px',
      'margin-bottom': $props.content.bottomMargin + 'px'
    }),
    onClick: _cache[0] || (_cache[0] = $event => $options.telPhone())
  }, [_withDirectives(_createElementVNode("div", {
    class: "telebuttom",
    style: _normalizeStyle({
      'background-color': $props.content.buttomColor,
      color: $props.content.buttomTextColor,
      width: $props.content.buttonW + '%',
      'min-height': $props.content.buttonH + 'px'
    })
  }, [_hoisted_1, _createElementVNode("div", {
    class: "box_title",
    style: _normalizeStyle({
      'font-size': $props.content.buttonSize + 'px'
    })
  }, _toDisplayString($props.content.name), 5)], 4), [[_vShow, $props.content.telType === 'left']]), _withDirectives(_createElementVNode("div", {
    class: "dial",
    style: _normalizeStyle({
      'justify-content': $props.content.logoFlex
    })
  }, [_createElementVNode("i", {
    style: _normalizeStyle({
      color: $props.content.logoColor,
      'font-size': $props.content.logoSize + 'px'
    }),
    class: "iconfont icon-temphone"
  }, null, 4)], 4), [[_vShow, $props.content.telType === 'right']])], 6);
}